import { render, staticRenderFns } from "./PersonalRecipientForm.vue?vue&type=template&id=f3ebb7ee&scoped=true&"
import script from "./PersonalRecipientForm.vue?vue&type=script&lang=js&"
export * from "./PersonalRecipientForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f3ebb7ee",
  null
  
)

export default component.exports